const getSelectStaffClient = () => {
    const selectStaffClient = localStorage.getItem("selectStaffClient")
        ? JSON.parse(localStorage.getItem("selectStaffClient"))
        : null;
    return selectStaffClient;
};

const InitialState = {
    selectStaffClient: getSelectStaffClient(),
};

const SelectedStaffClientReducer = (state = InitialState, action) => {
    if (action.type === "Select_Staff_Client") {
        const newState = {
            selectStaffClient: action.payload,
        };

        localStorage.setItem("selectStaffClient", JSON.stringify(action.payload));

        return newState;
    }

    //logout
    else if (action.type === "Remove_User") {
        const newState = {
            selectStaffClient: null,
        };

        localStorage.removeItem("selectStaffClient");
        return newState;
    }

    return state;
};

export default SelectedStaffClientReducer;
